import { useState } from "react"
import { AttrEditorProps } from "./editors"
import styles from "./index.module.less";
import classNames from "classnames"
import { Edge, Node } from "@antv/x6"
interface NodeAttrEditorProps {
  node: Node
  attrPath: string
  label: string
  Editor: React.FC<AttrEditorProps>
  initValue: string | number
  addonAfter?: any
}
export const NodeAttrEditor = (props: NodeAttrEditorProps) => {
  const {label, initValue, Editor, addonAfter, node, attrPath} = props;
  const [value, setValue] = useState(initValue)

  const onChange = (val) => {
    setValue(val)
    node.setPropByPath(attrPath, val)
  }

  const editorProps = {
    value,
    onChange,
    addonAfter
  }

  return <div className={classNames('flex-space-btw mt-1', styles.attrEditor)}>
    <div>{label}:</div>
    <div>
      <Editor {...editorProps} />
    </div>
  </div>
}